const getEventValues = (event) =>  {
    const initValues = {}

    if(event) {
        const { meta_data } = event

        Object.keys(meta_data).map(key => {
            initValues[key]  = event[meta_data[key].provider][key]
        })
    }

    return initValues
}

export default getEventValues